import { SWITCH_REPORTS_TOGGLED_ITEMS } from '../../actions/reportsToggledItemsActions';

const INITIAL_STATE = {
    toggledItems: {}
};

const updateToggledItems = (state, { payload }) => ({
    ...state,
    toggledItems: { ...state.toggledItems, ...payload }
});

// ======= Handler Assignments =======
const handlers = {
    [SWITCH_REPORTS_TOGGLED_ITEMS]: updateToggledItems
};

// ======= Default Action ======
/**
 * The purpose of this store is keeping track of toggled items (Pills/Chips/etc) on Reports when user switches dates.
 * The components should provide a unique key for the toggledItems that it can use to track state
 */
export default function reportsToggledItems(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function setReportsToggledItems(payload) {
    return {
        payload,
        type: SWITCH_REPORTS_TOGGLED_ITEMS
    };
}

// ======= Selectors =======
export const getReportsToggledItems = (state) => {
    return state.reportsToggledItems.toggledItems;
};
